export default __webpack_public_path__ + "static/media/topimg.09b58058.png";